import { TransactionInstruction, PublicKey, AccountMeta } from "@solana/web3.js" // eslint-disable-line @typescript-eslint/no-unused-vars
import BN from "bn.js" // eslint-disable-line @typescript-eslint/no-unused-vars
import * as borsh from "@coral-xyz/borsh" // eslint-disable-line @typescript-eslint/no-unused-vars
import * as types from "../types" // eslint-disable-line @typescript-eslint/no-unused-vars
import { PROGRAM_ID } from "../programId"

export interface DecompressV1Args {
  metadata: types.MetadataArgsFields
}

export interface DecompressV1Accounts {
  voucher: PublicKey
  leafOwner: PublicKey
  tokenAccount: PublicKey
  mint: PublicKey
  mintAuthority: PublicKey
  metadata: PublicKey
  masterEdition: PublicKey
  systemProgram: PublicKey
  sysvarRent: PublicKey
  tokenMetadataProgram: PublicKey
  tokenProgram: PublicKey
  associatedTokenProgram: PublicKey
  logWrapper: PublicKey
}

export const layout = borsh.struct([types.MetadataArgs.layout("metadata")])

/** Decompresses a leaf node from the tree. */
export function decompressV1(
  args: DecompressV1Args,
  accounts: DecompressV1Accounts,
  programId: PublicKey = PROGRAM_ID
) {
  const keys: Array<AccountMeta> = [
    { pubkey: accounts.voucher, isSigner: false, isWritable: true },
    { pubkey: accounts.leafOwner, isSigner: true, isWritable: true },
    { pubkey: accounts.tokenAccount, isSigner: false, isWritable: true },
    { pubkey: accounts.mint, isSigner: false, isWritable: true },
    { pubkey: accounts.mintAuthority, isSigner: false, isWritable: true },
    { pubkey: accounts.metadata, isSigner: false, isWritable: true },
    { pubkey: accounts.masterEdition, isSigner: false, isWritable: true },
    { pubkey: accounts.systemProgram, isSigner: false, isWritable: false },
    { pubkey: accounts.sysvarRent, isSigner: false, isWritable: false },
    {
      pubkey: accounts.tokenMetadataProgram,
      isSigner: false,
      isWritable: false,
    },
    { pubkey: accounts.tokenProgram, isSigner: false, isWritable: false },
    {
      pubkey: accounts.associatedTokenProgram,
      isSigner: false,
      isWritable: false,
    },
    { pubkey: accounts.logWrapper, isSigner: false, isWritable: false },
  ]
  const identifier = Buffer.from([54, 85, 76, 70, 228, 250, 164, 81])
  const buffer = Buffer.alloc(1000)
  const len = layout.encode(
    {
      metadata: types.MetadataArgs.toEncodable(args.metadata),
    },
    buffer
  )
  const data = Buffer.concat([identifier, buffer]).slice(0, 8 + len)
  const ix = new TransactionInstruction({ keys, programId, data })
  return ix
}
